<template>
  <div class="mob-trailer">
    <a :href="youtube.link" target="_blank" class="m-trailer external">
      <div
        class="m-trailer__wrapper"
        :style="`border: 10px solid ${bordercolor};`"
      >
        <video
          :src="require(`@/assets/videos/${sizzle}`)"
          loop
          muted
          autoplay
          playsinline
        ></video>
        <div class="m-trailer__text-wrapper">
          <img src="@/assets/images/youtube/play_white.png" alt="" />
          <div class="m-trailer__text">Trailer {{ number }} ansehen</div>
        </div>
      </div>

      <p class="m-trailer__note" :style="`color: ${color}`">
        Quelle: Youtube<br />
        Zum Ansehen des Videos müssen Sie auf den Play Button klicken. Wir
        möchten Sie darauf hinweisen, dass nach der Aktivierung Daten an Youtube
        übermittelt werden.
      </p>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    youtube: {
      type: Object,
      default: () => {},
    },
    sizzle: {
      type: String,
      default: 'sizzle.mp4',
    },
    number: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
      default: 'black',
    },
    bordercolor: {
      type: String,
      default: 'black',
    },
  },
}
</script>

<style lang="scss">
.m-trailer {
  position: relative;
  $self: &;
  background: transparent;
  display: block;
  text-decoration: none;
  &__wrapper {
    margin: 0% 5% 0% 5%;
    position: relative;
    cursor: pointer;
    video {
      width: 100%;
    }
    #{$self}__text-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 111;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 20%;
      }
      #{$self}__text {
        text-align: center;
        font-weight: 700;
        color: white;
        text-transform: uppercase;
        margin-top: 1rem;
      }
    }
  }
  &__note {
    margin: 1rem 5% 0 5%;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 400;
    &.sm {
      font-size: 0.5rem;
    }
  }
}
</style>
